<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="130px"
              class="eidt-el-form"
          >
            <el-form-item label="证件类型" prop="documentTypeId">
              <el-select
                  v-model="ruleForm.documentTypeId"
                  placeholder="选择证件类型"
              >
                <el-option
                    v-for="(type, index) in DocumentType"
                    :label="type.name"
                    :key="index"
                    :value="type.documentTypeId"
                    :lable="type.name"
                >
                  <div @click="getChangeType1(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目会议" prop="meetingId">
              <el-select
                  v-model="ruleForm.meetingId"
                  placeholder="选择项目会议"
              >
                <el-option
                    v-for="(type, index) in Meeting"
                    :label="type.name"
                    :key="index"
                    :value="type.meetingId"
                >
                  <div @click="getChangeType(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="可入人数" prop="total">
              <el-input
                  type="number"
                  min="0"
                  v-model="ruleForm.total"
              ></el-input>
            </el-form-item>
            <el-form-item label="已入人数" prop="count">
              <el-input
                  type="number"
                  min="0"
                  v-model="ruleForm.count"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";

export default {
  name: "edittypemanage",
  data() {
    return {
      Meeting: [],
      DocumentType: [],
      rules: {
        name: [
          {required: true, message: "请填写会议名称", trigger: "blur"},
        ],
        documentTypeId: [
          {required: true, message: "请选择证件类型", trigger: "blur"},
        ],
        meetingId: [
          {required: true, message: "请选择会议", trigger: "blur"},
        ],
        total: [
          {required: true, message: "可入人数", trigger: "blur"},
        ],
        count: [
          {required: true, message: "已入人数", trigger: "blur"},
        ],
      },
      ruleForm: {
        type: "",
        name: "",
        meetingId: null,
        documentTypeId: null,
        total: 0,
        count: 0,
        hall: "",
        startDate: "",
        endDate: "",
        projectId: localStorage.getItem("project_Id"),
      },
      dataList: [],
      projectId: "",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    arrarList: {
      type: Array,
      default() {
        return [];
      },
    },
    editData: {
      type: Object,
    },
  },
  created() {
    this.projectId = localStorage.getItem("project_Id");
    this.getDocumentType();
    this.getMeeting();
  },
  watch: {
    editData: function () {
      const item = this.editData;
      this.ruleForm = item ? item : this.ruleForm;
      this.meetingId = item.meetingId;
      this.editImg = item.logo;
    },
  },
  methods: {
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    getMeeting() {
      this.$axios.get("/Meeting/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.Meeting = [...res.data.data];
        }
      });
    },
    getChangeType(type) {
      this.ruleForm.startDate = type.startDate;
      this.ruleForm.endDate = type.endDate;
      this.ruleForm.hall = type.hall;
      this.ruleForm.name = type.name;
    },
    getChangeType1(type) {
      this.ruleForm.type = type.name;
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.meetingId == "" || this.meetingId == undefined) {
            this.$axios.post("/MeetingDocumentType/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/MeetingDocumentType/" + this.meetingId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.meetingId = "";
      this.editImg = "";
      this.$refs["ruleForm"].resetFields();
    },
    getUploadImg(imgSrc) {
      this.ruleForm.logo = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>
<style lang="scss" scope>
.img-box {
  float: right;
  width: 400px;
  position: absolute;
  top: 80px;
  right: 0px;
}

img {
  width: 100%;
}

#qrcode {
  position: absolute;
}
</style>